import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideInnFront } from 'inn-front-lib';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {authInterceptor} from "./app/core/interceptors/auth.interceptor";
import {errorInterceptor} from "./app/core/interceptors/error.interceptor";
import {networkMonitorInterceptor} from "./app/shared/components/dev-tools/network/network-monitor.interceptor";
import { provideRenderTracker } from "./app/shared/components/dev-tools/component-inspector/render-tracker.service";

registerLocaleData(localeEs);
/** Idioma guardado por LanguageService: fechas y números de los pipes salen en ese idioma (se aplica al cargar). */
const savedLanguage = localStorage.getItem('selectedLanguage') === 'es' ? 'es' : 'en';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),provideRouter(routes),
    { provide: LOCALE_ID, useValue: savedLanguage === 'es' ? 'es' : 'en-US' },
    // Los datepickers mantienen el formato en-US que ya entienden al teclear (NativeDateAdapter parsea con Date.parse).
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    // Todos los campos con borde (antes se repetía appearance="outline" en cada uno).
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    provideInnFront({ locale: savedLanguage }),
    // provideRenderTracker(),
    provideAnimations(),
    provideHttpClient(
        withFetch(),
        withInterceptors([networkMonitorInterceptor, authInterceptor, errorInterceptor])
    ),
    importProvidersFrom([
      MatToolbarModule,
      MatSidenavModule,
      MatListModule,
      MatIconModule,
      MatButtonModule,
      MatCardModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule,
      MatDialogModule,
      MatChipsModule,
      MatProgressSpinnerModule,
      MatSnackBarModule,
      MatTabsModule,
      MatExpansionModule,
      MatCheckboxModule,
      MatRadioModule,
      MatMenuModule,
      ReactiveFormsModule,
    ])
  ]
});
